export const programData = [
  {
    id: 1,
    title: 'Який формат курсу?',
    desc: 'Ви отримаєте 14 відеоуроків тривалістю 2-5 хвилин. Всі уроки відкриються одразу після оплати у Telegram-каналі.',
  },
  {
    id: 2,
    title: 'Як довго я матиму доступ до уроків?',
    desc: 'Доступ до уроків необмежений',
  },
  {
    id: 3,
    title: 'Яка мова курсу?',
    desc: 'Мова курсу - українська',
  },
];
